import { Application } from '@hotwired/stimulus'
import ConversionsController from './conversions_controller'
import GoogleAnalyticsFormController from './google_analytics_form_controller'
import GoogleAdsFormController from './google_ads_form_controller'
import CampaignSelectController from './campaign_select_controller'
import ToggleDependentsController from './toggle_dependents_controller'
import NumberMatcherDestroyController from './number_matcher_destroy_controller'
import LockButtonController from './lock_button_controller'
import RemoveElementsController from './remove_elements_controller'
import CopyCodeController from './copy_code_controller'
import WidgetsController from './widgets_controller'
import ChartsJsController from './charts_js_controller'
import ChartsJsActionController from './charts_js_action_controller'
import ClickhouseDrillDownToolbarController from './clickhouse_drill_down_toolbar_controller'
import ClickhouseDrillDownRowController from './clickhouse_drill_down_row_controller'
import TomSelectController from './tom_select_controller'
import CheckboxToggleController from './checkbox_toggle_controller'
import CreditCardsFormController from './credit_cards_form_controller'
import DraftController from './draft_controller'
import TagWizard from './tag_wizard_controller'
import ReplacementTokensController from './replacement_tokens_controller'
import DateRangePickerController from './date_range_picker_controller'
import FileUploadController from './file_upload_controller'
import AutoResizeController from './auto_resize_controller'
import BootstrapController from './bootstrap_controller'
import StateSelectController from './state_select_controller'
import TwoFactorController from './two_factor_controller'
import GoogleMapsController from './google_maps_controller'
import HubspotFormController from './hubspot_form_controller'
import YoutubePlayerController from './youtube_player_controller'
import DynamicFormRowsController from './dynamic_form_rows_controller'
import LazyLoadJsController from './lazy_load_js_controller'
import ScrollSnapController from './scroll_snap_controller'
import MarketingAnimationsController from './marketing_animations_controller'
import ColorpickerController from './colorpicker_controller'
import VirtualScrollbarController from './virtual_scrollbar_controller'
import BootstrapCollapseChevronController from './bootstrap_collapse_chevron_controller'
import FilterManagerController from './filter_manager_controller'
import RevealOnScrollController from './reveal_on_scroll_controller'
import AlertDismissalController from './alert_dismissal_controller'
import SecretKeyController from './secret_key_controller'
import DetailViewController from './detail_view_controller'
import ChevronLoadingIconsController from './chevron_loading_icons_controller'
import QrCodeController from './qr_code_controller'
import WebhookConfiguratorController from './webhook_configurator_controller'
import ListSearchController from './list_search_controller'
import BootstrapDropdownAutofocusController from './bootstrap_dropdown_autofocus_controller'
import BootstrapCollapseAllButtonController from './bootstrap_collapse_all_button_controller'
import NumberSelectorController from './number_selector_controller'
import ClearInputButtonController from './clear_input_button_controller'
import HtmlBoxesTheSameHeightController from './html_boxes_the_same_height_controller'
import SortableController from './sortable_controller'
import ToggleTableColumnController from './toggle_table_column_controller'
import ShowElementController from './show_element_controller'
import GridstackController from './gridstack_controller'
import TranscriptionConfigController from './transcription_config_controller'
import OnChangeFormSubmitterController from './on_change_form_submitter_controller'
import CallsClickhouseExportController from './calls_clickhouse_export_controller'
import TomSelectTargetSearchController from './tom_select_target_search_controller'

const application = Application.start()

// Make application available globally for turbo-mount
window.Stimulus = application

application.debug = false
application.register('google-analytics-form', GoogleAnalyticsFormController)
application.register('google-ads-form', GoogleAdsFormController)
application.register('campaign-select', CampaignSelectController)
application.register('toggle-dependents', ToggleDependentsController)
application.register('number-matcher-destroy', NumberMatcherDestroyController)
application.register('conversions', ConversionsController)
application.register('lock-button', LockButtonController)
application.register('copy-code', CopyCodeController)
application.register('widgets-refresh-after', WidgetsController)
application.register('charts-js', ChartsJsController)
application.register('charts-js-action', ChartsJsActionController)
application.register('tom-select', TomSelectController)
application.register('tom-select-target-search', TomSelectTargetSearchController)
application.register('credit-cards-form', CreditCardsFormController)
application.register('clickhouse-drill-down-toolbar', ClickhouseDrillDownToolbarController)
application.register('clickhouse-drill-down-row', ClickhouseDrillDownRowController)
application.register('date-range-picker', DateRangePickerController)
application.register('draft', DraftController)
application.register('replacement-tokens', ReplacementTokensController)
application.register('file-upload', FileUploadController)
application.register('state-select', StateSelectController)
application.register('two-factor', TwoFactorController)
application.register('google-maps', GoogleMapsController)
application.register('bootstrap', BootstrapController)
application.register('hubspot-form', HubspotFormController)
application.register('youtube-player', YoutubePlayerController)
application.register('detail-view', DetailViewController)
application.register('tag-wizard', TagWizard)
application.register('lazy-load-js', LazyLoadJsController)
application.register('scroll-snap', ScrollSnapController)
application.register('marketing-animations', MarketingAnimationsController)
application.register('virtual-scrollbar', VirtualScrollbarController)
application.register('bootstrap-collapse-chevron', BootstrapCollapseChevronController)
application.register('chevron-loading-icons', ChevronLoadingIconsController)
application.register('filter-manager', FilterManagerController)
application.register('remove-elements', RemoveElementsController)
application.register('checkbox-toggle', CheckboxToggleController)
application.register('auto-resize', AutoResizeController)
application.register('secret-key', SecretKeyController)
application.register('qr-code', QrCodeController)
application.register('dynamic-form-rows', DynamicFormRowsController)
application.register('colorpicker', ColorpickerController)
application.register('reveal-on-scroll', RevealOnScrollController)
application.register('alert-dismissal', AlertDismissalController)
application.register('webhook-configurator', WebhookConfiguratorController)
application.register('list-search', ListSearchController)
application.register('bootstrap-dropdown-autofocus', BootstrapDropdownAutofocusController)
application.register('bootstrap-collapse-all-button', BootstrapCollapseAllButtonController)
application.register('number-selector', NumberSelectorController)
application.register('clear-input-button', ClearInputButtonController)
application.register('html-boxes-the-same-height', HtmlBoxesTheSameHeightController)
application.register('sortable', SortableController)
application.register('toggle-table-column', ToggleTableColumnController)
application.register('show-element', ShowElementController)
application.register('gridstack', GridstackController)
application.register('transcription-config', TranscriptionConfigController)
application.register('on-change-form-submitter', OnChangeFormSubmitterController)
application.register('calls-clickhouse-export', CallsClickhouseExportController)
